function fireConfettiFromElement(el) {
  if (typeof confetti !== 'function') return;

  const rect = el.getBoundingClientRect();

  confetti({
    particleCount: 120,
    spread: 80,
    origin: {
      x: (rect.left + rect.width / 2) / window.innerWidth,
      y: (rect.top + rect.height / 2) / window.innerHeight
    }
  });
}

/* =========================
   ADICIONAR AO CARRINHO
   ========================= */
document.addEventListener('submit', function (event) {
  const form = event.target.closest('form[action^="/cart/add"]');
  if (!form) return;

  const button = form.querySelector('.product-form__submit');
  if (button) fireConfettiFromElement(button);
});

/* =========================
   COMPRE JÁ (BUY IT NOW)
   ========================= */
document.addEventListener('click', function (event) {
  const wrapper = event.target.closest('.shopify-payment-button');
  if (!wrapper) return;

  fireConfettiFromElement(wrapper);
});